export default __webpack_public_path__ + "static/media/popup_251114_1.bcc7eb7a.png";